import React from 'react';
import type { FC } from 'react';

interface HelpIconProps {
    className?: string;
}

export const HelpIcon: FC<HelpIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Help Icon</title>
            <g clipPath="url(#clip0_2632_9222)">
                <path
                    d="M12.9985 17.5H4.9987C4.55667 17.5 4.13275 17.3244 3.82019 17.0118C3.50763 16.6993 3.33203 16.2754 3.33203 15.8333V4.16667C3.33203 3.72464 3.50763 3.30072 3.82019 2.98816C4.13275 2.67559 4.55667 2.5 4.9987 2.5H14.9987C15.4407 2.5 15.8646 2.67559 16.1772 2.98816C16.4898 3.30072 16.6654 3.72464 16.6654 4.16667V9.16667"
                    stroke="white"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path d="M7.5 15H11.6667" stroke="white" strokeLinecap="square" strokeLinejoin="round" />
                <path d="M15.832 17.5V17.51" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M14.582 12.084C14.8227 11.7997 15.1525 11.6051 15.5177 11.5321C15.883 11.459 16.2622 11.5116 16.5937 11.6815C16.9255 11.8531 17.1901 12.1311 17.3452 12.471C17.5003 12.8109 17.5369 13.193 17.4492 13.5561C17.3614 13.9192 17.1544 14.2424 16.8612 14.4739C16.568 14.7055 16.2056 14.8319 15.832 14.8331V15.9031"
                    stroke="white"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2632_9222">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
